import { SET_LOADER } from "../constats/loader.constant";

export const setLoading = (bool) => (dispatch) => {
    dispatch({
        type: SET_LOADER,
        payload: bool
    });
}